import { Menu, X } from 'lucide-react';
import React, { useState } from 'react';

const Navbar = ({ onNavigate, currentPage }) => {
  const [isOpen, setIsOpen] = useState(false);

  const menuItems = [
    { id: 'home', label: 'Home' },
    { id: 'info', label: 'Info' }
  ];

  const handleNavigation = (pageId) => {
    onNavigate(pageId);
    setIsOpen(false);
  };

  return (
    <nav className="fixed w-full bg-white/80 backdrop-blur-md z-[100] border-b border-gray-100">
      <div className="container mx-auto px-6 py-3">
        <div className="flex items-center gap-1">
          {/* Hamburger Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="p-2 text-gray-600 hover:text-gray-900 focus:outline-none rounded-lg hover:bg-gray-100/50 transition-colors"
          >
            {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>

          <button 
            onClick={() => handleNavigation('home')}
            className="flex items-center py-2"
          >
            <svg 
              width="220"
              viewBox="50 0 300 100"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g transform="translate(0, 10)">
                <rect x="70" y="35" 
                      width="38" height="38" 
                      rx="12"
                      fill="none"
                      stroke="#7C3AED"
                      strokeWidth="2.5"
                      opacity="0.15"
                      transform="rotate(-15 89 54)"/>
                
                <rect x="81" y="15" 
                      width="38" height="38"
                      rx="12"
                      fill="none"
                      stroke="#7C3AED"
                      strokeWidth="2.5"
                      opacity="0.45"/>
                
                <rect x="92" y="35" 
                      width="38" height="38"
                      rx="12"
                      fill="none"
                      stroke="#7C3AED"
                      strokeWidth="2.5"
                      transform="rotate(15 111 54)"/>
              </g>
              
              <text x="140" y="65"
                    fontFamily="system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif" 
                    fontSize="42"
                    fontWeight="400"
                    textAnchor="start" 
                    fill="#7C3AED"
                    letterSpacing="-0.5">
                skillhub
              </text>
            </svg>
          </button>
        </div>

        {/* Menu Panel */}
        {isOpen && (
          <div className="absolute top-full left-6 w-48 mt-2">
            <div className="bg-white rounded-lg shadow-lg border border-gray-100 overflow-hidden">
              {menuItems.map((item) => (
                <button
                  key={item.id}
                  onClick={() => handleNavigation(item.id)}
                  className={`block w-full text-left px-4 py-3 text-lg hover:bg-gray-50 transition-colors ${
                    currentPage === item.id
                      ? 'bg-purple-50 text-purple-600 font-medium'
                      : 'text-gray-600'
                  }`}
                >
                  {item.label}
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;